import { initFederation } from '@angular-architects/native-federation';
const manifestUrl = `federation.manifest.json?v=${Date.now()}`;

function getRuntimeFlag(flagName: string): string | null {
  const searchValue = new URLSearchParams(window.location.search).get(flagName);
  if (searchValue) return searchValue;

  const hashQuery = window.location.hash.split('?')[1] || '';
  return new URLSearchParams(hashQuery).get(flagName);
}

function getRuntimeManifest(manifest: Record<string, string>): Record<string, string> {
  const isLocalHost = ['localhost', '127.0.0.1'].includes(window.location.hostname);
  const loadLocalRemotes = getRuntimeFlag('withRemotes') === '1';

  if (isLocalHost || loadLocalRemotes) {
    return manifest;
  }

  const filteredEntries = Object.entries(manifest).filter(([, url]) => !url.includes('localhost:'));
  return Object.fromEntries(filteredEntries);
}

function withCacheBuster(manifest: Record<string, string>): Record<string, string> {
  const version = Date.now();
  const entries = Object.entries(manifest).map(([name, url]) => [name, `${url}${url.includes('?') ? '&' : '?'}v=${version}`]);
  return Object.fromEntries(entries);
}

fetch(manifestUrl)
  .then((response) => {
    if (!response.ok) {
      throw new Error(`Failed to fetch federation manifest: ${response.status} ${response.statusText}`);
    }
    return response.json();
  })
  .then((manifest) => {
    const runtimeManifest = withCacheBuster(getRuntimeManifest(manifest as Record<string, string>));
    return initFederation(runtimeManifest);
  })
  .catch((err) => {
    console.error('Error loading the federation manifest:', err);
  })
  .then(() => import('./bootstrap'))
  .catch((err) => console.error('Error during the bootstrap:', err));
